<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="$parent.closeTopup" />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              src="./../image/close.svg"
              class="close"
              @click="$parent.closeTopup"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="cart-up" v-if="step == 1">
                  <div class="cart-top">
                    <div class="desc">
                      <b>{{ $t("ADDING FUNDS TO BALANCE") }}</b>
                    </div>
                  </div>
                  <div class="topup-form">
                    <div class="desc">
                      {{ $t("PAYMENT METHOD:") }}
                    </div>
                    <div class="desc">
                      {{ $t("CREDIT CARD") }}
                    </div>

                    <label class="input-container">
                      <div class="desc">
                        {{ $t("Name") }}
                      </div>
                      <input
                        v-model="name"
                        type="text"
                        required
                        :placeholder="$t('Name')"
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">
                        {{ $t("Surname") }}
                      </div>
                      <input
                        v-model="surname"
                        type="text"
                        required
                        :placeholder="$t('Surname')"
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">
                        {{ $t("Phone") }}
                      </div>
                      <input
                        v-model="phone"
                        type="tel"
                        required
                        :placeholder="$t('Phone')"
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">
                        {{ $t("Country") }}
                      </div>
                      <select required v-model="selectedCountry">
                        <option value="" disabled selected>
                          {{ $t("Countries") }}
                        </option>
                        <option
                          v-for="item in countries"
                          :key="item.id"
                          :value="item"
                        >
                          {{ item.title }}
                        </option>
                      </select>
                    </label>
                    <label class="input-container">
                      <div class="desc">
                        {{ $t("City") }}
                      </div>
                      <input
                        v-model="city"
                        type="text"
                        :placeholder="$t('City')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">
                        {{ $t("Address") }}
                      </div>
                      <input
                        v-model="address"
                        type="text"
                        :placeholder="$t('Address')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">
                        {{ $t("Post Code") }}
                      </div>
                      <input
                        v-model="postCode"
                        type="text"
                        :placeholder="$t('Post Code')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">
                        {{ $t("Enter amount") }}
                      </div>
                      <input
                        v-model="amount"
                        type="text"
                        :placeholder="$t('Enter amount')"
                        @input="allowOnlyNumbers"
                        required
                      />
                      <div class="desc desc-curr">
                        {{ $parent.currency }}
                      </div>
                    </label>
                    <div class="cta-container">
                      <div class="chekbox-container">
                        <label class="chekbox-label">
                          <div class="chekbox-label-wrapper">
                            <input
                              v-model="terms"
                              type="checkbox"
                              name="terms"
                            />
                            <div class="checkbox" />
                            <span class="title">{{ $t("I agree with") }} </span>
                            <a
                              class="title"
                              @click="$parent.goToPage('privacy')"
                            >
                              {{ $t("Privacy Policy") }}</a
                            >
                            <span class="title"> {{ $t("and") }} </span>
                            <a class="title" @click="$parent.goToPage('terms')">
                              {{ $t("Terms and Conditions") }}</a
                            >
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cart-up" v-if="step == 2">
                  <div class="cart-top">
                    <div class="desc">
                      <b>{{ $t("ADDING FUNDS TO BALANCE") }}</b>
                    </div>
                  </div>
                  <div class="topup-form">
                    <ValidationObserver
                      v-slot="{ invalid, handleSubmit }"
                      ref="card_form"
                    >
                      <label class="label input-container">
                        <div class="desc">{{ $t("Card number") }}</div>
                        <ValidationProvider
                          name="formattedPan"
                          v-slot="{ errors }"
                        >
                          <input
                            type="text"
                            :placeholder="$t('Card number')"
                            :value="formattedPan"
                            @input="onCardNumberInput"
                          />
                          <span v-if="errors[0]" class="error">{{
                            $t(errors[0])
                          }}</span>
                        </ValidationProvider>
                      </label>

                      <!-- Expiration Date -->
                      <label class="label input-container">
                        <div class="desc">
                          {{ $t("Expiration Date") }} (MM/YY)
                        </div>
                        <ValidationProvider
                          name="expiration_date"
                          v-slot="{ errors }"
                        >
                          <input
                            type="text"
                            :placeholder="$t('MM/YY')"
                            :value="expiration_date"
                            @input="onExpirationInput"
                          />
                          <span v-if="errors[0]" class="error">{{
                            $t(errors[0])
                          }}</span>
                        </ValidationProvider>
                      </label>

                      <!-- Card Holder Name -->
                      <label class="label input-container">
                        <div class="desc">{{ $t("Card Holder Name") }}</div>
                        <ValidationProvider
                          name="card_holdername"
                          v-slot="{ errors }"
                        >
                          <input
                            type="text"
                            :placeholder="$t('Card Holder Name')"
                            :value="card_holdername"
                            @input="onCardHolderInput"
                          />
                          <span v-if="errors[0]" class="error">{{
                            $t(errors[0])
                          }}</span>
                        </ValidationProvider>
                      </label>

                      <!-- CVV -->
                      <label class="label input-container">
                        <div class="desc">{{ $t("CVV") }}</div>
                        <ValidationProvider name="card_cvv" v-slot="{ errors }">
                          <input
                            type="text"
                            :placeholder="$t('CVV')"
                            :value="card_cvv"
                            @input="onCvvInput"
                          />
                          <span v-if="errors[0]" class="error">{{
                            $t(errors[0])
                          }}</span>
                        </ValidationProvider>
                      </label>
                    </ValidationObserver>
                  </div>
                </div>
                <div class="cart-bottom">
                  <div class="desc">
                    {{ $t("You will get") }}:
                    <b>{{ $parent.currency }} {{ amount }}</b>
                  </div>
                  <button
                    v-if="step == 1"
                    @click="step = 2"
                    :class="[
                      'button orange',
                      { disabled: !requiredRegisterFieldsAreFilled },
                    ]"
                  >
                    {{ $t("Next") }}
                  </button>
                  <button
                    v-if="step == 2"
                    :class="[
                      'button orange',
                      { disabled: !requiredRegisterFieldsAreFilled || loader },
                    ]"
                    @click="send"
                  >
                    <div v-if="loader" class="loader"></div>
                    <span v-if="!loader">{{ $t("Pay") }}</span>
                  </button>
                </div>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $t($parent.error) }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  name: "TopUp",
  props: [],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: function () {
    return {
      amount: 5,
      name: "",
      surname: "",
      phone: "",
      country: "",
      selectedCountry: "",
      countryId: "",
      city: "",
      address: "",
      postCode: "",
      countryOptions: [],
      countryOptionsId: [],
      paymentType: "",
      countries: [],
      terms: "",
      step: 1,
      formattedPan: "",
      expiration_date: "",
      card_holdername: "",
      card_cvv: "",
      loader: false,
    };
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (this.terms) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  mounted() {
    this.getCounties();
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.phone = res.data.phone;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.countryId = res.data.country;
        this.city = res.data.city;
        this.address = res.data.address;
        this.postCode = res.data.zip;

        if (this.countries && this.countries.length && this.countryId) {
          this.setCountry();
        }
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignIn();
        }
      });
  },
  methods: {
    formatCardCvv(value) {
      value = value.replace(/\D/g, "");
      return value.slice(0, 3);
    },
    formatCardNumber(value) {
      value = value.replace(/\D/g, "");
      if (value.length > 16) value = value.slice(0, 16);
      return value.replace(/(\d{4})(?=\d)/g, "$1 ");
    },
    formatExpirationDate(value) {
      value = value.replace(/\D/g, "");
      if (value.length > 4) value = value.slice(0, 4);
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }
      const [month] = value.split("/");
      if (month && parseInt(month, 10) > 12) {
        value = "12" + value.slice(2);
      }
      return value;
    },
    formatCardHolderName(value) {
      value = value.replace(/[^A-Za-z\s]/g, "").replace(/\s+/g, " ");
      const words = value.trim().split(" ");
      if (words.length > 2) value = words.slice(0, 2).join(" ");
      return value.toUpperCase();
    },

    // Input Handlers
    onCardNumberInput(e) {
      const masked = this.formatCardNumber(e.target.value);
      this.formattedPan = masked;
    },
    onExpirationInput(e) {
      this.expiration_date = this.formatExpirationDate(e.target.value);
    },
    onCardHolderInput(e) {
      this.card_holdername = this.formatCardHolderName(e.target.value);
    },
    onCvvInput(e) {
      const masked = this.formatCardCvv(e.target.value);
      this.card_cvv = masked;
    },
    setCountry() {
      let mapped = this.countries.map(({ id, title }) => ({
        id,
        title,
      }));
      this.countries = mapped;
      this.selectedCountry = this.countries.find(
        (item) => item.id == this.countryId
      );

      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.countryOptions[i] == this.selectedCountry.name) {
          this.countryId = this.countryOptionsId[i];
        }
      }
    },
    selectCountry(event) {
      this.country = event.text;
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.countryOptions[i] == event.text) {
          this.countryId = this.countryOptionsId[i];
        }
      }
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          let arr = res.data.payload;
          let newCountries = arr.map(function (item) {
            return item["title"];
          });
          let newCountriesId = arr.map(function (item) {
            return item["id"];
          });
          this.countryOptionsId = newCountriesId;
          this.countryOptions = newCountries;
          this.countries = arr;
          let mapped = this.countries.map(({ id, title }) => ({
            id,
            title,
          }));
          this.countries = mapped;

          if (this.countries && this.countries.length && this.countryId) {
            this.setCountry();
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9.,]/g, "");

      // Split the input into integer and decimal parts
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];

      // Limit decimal part to two digits
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }

      // Concatenate the integer and decimal parts back
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    send() {
      this.loader = true;
      const [expiry_month, expiry_year] = this.expiration_date.split("/");
      let data = {
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        amount: this.amount,
        country: this.selectedCountry.id,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
        card_number: this.formattedPan.replace(/\s+/g, ""),
        expiry_month,
        expiry_year,
        cardholder_name: this.card_holdername,
        cvv: this.card_cvv,
      };
      this.$http
        .post(process.env.VUE_APP_API + "deposit/checkout/execute", data)
        .then((res) => {
          let self = this;
          if (res.data.status == "OK") {
            var timer = setInterval(function () {
              if (res.data.statusUrl) {
                self.$http.get(res.data.statusUrl).then((response) => {
                  if (response.data && response.data.redirect_url) {
                    clearInterval(timer);
                    self.loader = false;
                    window.location.href = response.data.redirect_url;
                  }
                });
              }
            }, 1000);
          } else {
            this.$emit("setError", res.data.message);
            this.loader = false;
          }
        })
        .catch((res) => {
          this.loader = false;
          this.$emit("setError", res.response.data.message);
        });
    },
  },
};
</script>
